import { observer } from "mobx-react-lite";
import React, { useContext } from "react";

import { UserContext } from "../contexts";
import {
  IconName,
  Inclusion,
  InclusionSection,
  InclusionSectionContent,
  Promotion,
} from "../types";
import Collapsable from "./Collapsable";
import Icon from "./Icon";

const InclusionDetail = observer(
  (props: {
    inclusion: Inclusion | Promotion;
    onClickBack?: () => void;
    onClickNext?: () => void;
    nextBtnTitle?: string;
    hideBlurb?: boolean;
    firstExpanded?: boolean;
    hideImages?: boolean;
  }) => {
    const userContext = useContext(UserContext);

    const getSectionContentImageOverride = (
      content: InclusionSectionContent
    ) => {
      if(props.hideImages) {
        return undefined;
      }
      // Selecting an interior style can override the upgrade image shown
      let image = content.image;
      if (content.image_overrides && userContext.selectedInteriorStyle) {
        if (
          Object.keys(content.image_overrides).indexOf(
            userContext.selectedInteriorStyle.id.toString()
          ) > -1
        ) {
          image = content.image_overrides[userContext.selectedInteriorStyle.id];
        }
      }
      return image;
    };

    const renderExpandContent = (section: InclusionSection) => {
      return (
        <div className={"inclusion-section"}>
          <div className={"inclusion-section-items"}>
            {section.content.map((content, index) => {
              return (
                <div className={"inclusion-section-item"} key={index}>
                  {getSectionContentImageOverride(content) && (
                    <div className={"image-container"}>
                      <img
                        src={getSectionContentImageOverride(content)}
                        alt={""}
                      />
                    </div>
                  )}
                  <h3 className={"title"}>{content.title.replace(/<\/?[^>]+(>|$)/g, "")}</h3>
                  <div
                    className={"copy"}
                    dangerouslySetInnerHTML={{ __html: content.copy }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      );
    };

    const onClickFooterCenter = () => {
      const $footerCenter = $(".footer-center");
      const $breakdownContent = $footerCenter.find(".breakdown-content");
      if($footerCenter){
        if($footerCenter.hasClass("active")){
          $footerCenter.removeClass("active");
          $breakdownContent.slideUp();
        }else{
          $footerCenter.addClass("active");
          $breakdownContent.slideDown();
        }
      }
    };

    return (
      <div className={"pyht-inclusion-detail"}>
        <div className={"container"}>
          {!props.hideBlurb && (
            <div
              className={"blurb copy"}
              dangerouslySetInnerHTML={{ __html: props.inclusion.blurb }}
            />
          )}

          {props.inclusion.sections.map((section, index) => {
            return (
              <Collapsable
                key={section.id}
                titleContent={<h2 className={"title"}>{section.title.replace(/<\/?[^>]+(>|$)/g, "")}</h2>}
                expandContent={renderExpandContent(section)}
                startExpanded={index == 0}
              />
            );
          })}
        </div>
        <div className={"footer-nav-container"}>
          <div className={"footer-nav"}>
            <div className={"container"}>
              <div className={"footer-left"}>
                <div className={"back-btn-container"}>
                  <button
                    className={"btn btn-black back-btn"}
                    onClick={props.onClickBack}
                  >
                    <Icon name={IconName.ARROW} />
                    <span>Back</span>
                  </button>
                </div>
              </div>
              <div className={"footer-center"}
                onClick={onClickFooterCenter}>
                <div className={"breakdown"}>
                  <div className={"breakdown-label"}><Icon name={IconName.CHEVRON_UP_WHITE} /><span>cost breakdown</span></div>
                  <div className={"breakdown-content"}>
                    <div className={"breakdown-row"}>
                      <span className={"breakdown-row-label"}>Base Price</span>
                      <span className={"breakdown-row-value"}>${userContext.basePrice.toLocaleString()}</span>
                    </div>
                    <div className={"breakdown-row"}>
                      <span className={"breakdown-row-label"}>Additional Selections</span>
                      <span className={"breakdown-row-value"}>${(userContext.totalPrice - userContext.basePrice).toLocaleString()}</span>
                    </div>
                  </div>
                </div>
                <span className={"subtotal-title"}>Subtotal</span>
                <span className={"subtotal-price"}>
                  ${userContext.totalPrice.toLocaleString()}
                </span>
              </div>
              <div className={"footer-right"}>
                <div className={"next-btn-container"}>
                  {props.onClickNext && (
                    <button
                      className={"btn next-btn"}
                      onClick={() => props.onClickNext && props.onClickNext()}
                    >
                      {props.nextBtnTitle
                        ? props.nextBtnTitle
                        : "Select This Package"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          {props.onClickNext && (
            <div className={"container mobile-next"}>
              <button
                className={"btn"}
                onClick={() => props.onClickNext && props.onClickNext()}
              >
                {props.nextBtnTitle
                  ? props.nextBtnTitle
                  : "Select This Package"}
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
);

export default InclusionDetail;
